import styled from '@emotion/styled';
import { Badge, Box, Grid, Paper } from '@mui/material';
import React from 'react';
import { setColor } from '../store/constant';

const setColor2 = {
  true: {
    dark: {
      done: {
        bg: '#255226',
        color: '#9ff1a5',
      },
      start: {
        bg: '#f1c40f',
        color: '#121212',
      },
      default: {
        bg: '#121212',
        color: '#fff',
      },
    },
    light: {
      done: {
        bg: '#a5d6a7',
        color: '#121212',
      },
      start: {
        bg: '#fbff17',
        color: '#121212',
      },
      default: {
        bg: '#d3d3d3',
        color: '#121212',
      },
    },
  },
  false: {
    dark: {
      done: {
        bg: '#7a3b27',
        color: '#b9b9b9',
      },
      start: {
        bg: '#7a3b27',
        color: '#b9b9b9',
      },
      default: {
        bg: '#7a3b27',
        color: '#b9b9b9',
      },
    },
    light: {
      done: {
        bg: '#ffad93',
        color: '#121212',
      },
      start: {
        bg: '#ffad93',
        color: '#121212',
      },
      default: {
        bg: '#ffad93',
        color: '#121212',
      },
    },
  },
};

const Item2 = styled(Paper)(({ theme, dark, light, py, isdone, visible }) => ({
  backgroundColor:
    setColor[visible][theme.palette.mode][isdone === '' ? 'default' : isdone][
      'bg'
    ],
  // visible === 'false'
  //   ? theme.palette.mode === 'dark'
  //     ? '#7a3b27'
  //     : '#ffad93'
  //   : theme.palette.mode === 'dark'
  //   ? isdone === 'done'
  //     ? '#1b5e20'
  //     : theme.palette.secondary
  //   : light,
  ...theme.typography.body2,
  padding: theme.spacing(0),
  paddingTop: theme.spacing(py),
  paddingBottom: theme.spacing(py),
  //marginRight: theme.spacing(1),
  textAlign: 'center',
  color:
    setColor[visible][theme.palette.mode][isdone === '' ? 'default' : isdone][
      'color'
    ],
  cursor: 'pointer',
}));

const Item = styled(Paper)(({ theme, dark, light, py, isdone, visible }) => ({
  backgroundColor:
    visible === 'false'
      ? theme.palette.mode === 'dark'
        ? '#7a3b27'
        : '#ffad93'
      : theme.palette.mode === 'dark'
        ? isdone === 'done'
          ? '#1b5e20'
          : theme.palette.secondary
        : light,
  ...theme.typography.body2,
  padding: theme.spacing(0),
  paddingTop: theme.spacing(py),
  paddingBottom: theme.spacing(py),
  //marginRight: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.mode === 'dark' ? dark : theme.palette.text.disabled,
  cursor: 'pointer',
}));

const DiscreteLineV2 = ({
  data,
  projectId,
  py = 0,
  selectedTab,
  setSelectedTab,
  images,
  notitle,
  showStages,
  handleSwitchTurn,
  canSetStages = false,
}) => {
  function getBgColorDark(state) {
    if (state === 'done') {
      return '#4caf50';
    } else if (state === 'start') {
      return '#fbff17';
    } else {
      return '#d3d3d3';
    }
  }

  function getBgColorLight(state) {
    if (state === 'done') {
      return '#a5d6a7';
    } else {
      return '#d3d3d3';
    }
  }
  //в массиве будут ID тех этапов, у которых есть фотографии
  let stagesWithImage = [];
  if (Array.isArray(images)) {
    images.forEach((item) => {
      stagesWithImage.push(item.stage);
    });
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={0}>
        {data &&
          data.map((item, index) => (
            <Grid item xs key={index}>
              {/* Этот блок для страницы Проект */}
              {typeof setSelectedTab === 'function' ? (
                <Item2
                  sx={{ cursor: canSetStages ? 'pointer' : 'auto' }}
                  py={py}
                  //dark={getBgColorDark(item.state)}
                  //light={getBgColorLight(item.state)}
                  isdone={item.state}
                  visible={item.visible ? 'true' : 'false'}
                  onClick={() => {
                    if (stagesWithImage.includes(item._id)) {
                      setSelectedTab(item._id);
                    }
                  }}
                >
                  {selectedTab === item._id ? (
                    <Badge color='primary' size='large' variant='dot'>
                      {<strong>{item?.shortName}</strong>}
                    </Badge>
                  ) : stagesWithImage.includes(item._id) ? (
                    <Badge
                      color='success'
                      variant='dot'
                      size='small'
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                    >
                      {item?.shortName}
                    </Badge>
                  ) : (
                    item?.shortName
                  )}
                </Item2>
              ) : (
                <>
                  {typeof handleSwitchTurn === 'function' ? (
                    <Item2
                      py={notitle ? 0.5 : py}
                      sx={{ cursor: canSetStages ? 'pointer' : 'auto' }}
                      //dark={getBgColorDark(item.state)}
                      //light={getBgColorLight(item.state)}
                      isdone={item.state}
                      visible={item.visible ? 'true' : 'false'}
                      onClick={() =>
                        handleSwitchTurn(
                          item?.linkId,
                          item.state === 'done' ? '' : 'done',
                          projectId,
                          item.visible,
                        )
                      }
                    >
                      {notitle ? '' : item?.shortName}
                    </Item2>
                  ) : (
                    <Item2
                      py={notitle ? 0.5 : py}
                      //dark={getBgColorDark(item.state)}
                      //light={getBgColorLight(item.state)}
                      isdone={item.state}
                      visible={item.visible ? 'true' : 'false'}
                    >
                      {notitle ? '' : item?.shortName}
                    </Item2>
                  )}
                </>
              )}
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default DiscreteLineV2;
